<app-base-drawer [name]="'columnsDrawer'" style="width: 22.125rem; z-index: 999">
  <div class="columns-drawer-wrapper">
    <header class="header">
      <div class="headline-x-small">Columnas</div>
    </header>
    
    <div class="drawer-content">
      <div class="columns-list">
        <div class="column-group" *ngFor="let column of columnDefs; trackBy: trackByFn">
          <div class="column-header" (click)="column.expanded = !column.expanded">
            <div class="headline-x-small">{{ column.headerName }}</div>
            <i class="ri-arrow-down-s-line" 
               [class.expanded]="column.expanded">
            </i>
          </div>
          
          <div class="filter-content" [class.expanded]="column.expanded">
            <div class="filter-content-inner">
              <div class="visibility-control">
                <div class="filter-title body-small">Visibilidad</div>
                <app-checkbox-item
                  [(checked)]="column.visible"
                  (checkedChange)="onVisibleChanged(column)"
                >
                  <div class="body-small">Mostrar columna</div>
                </app-checkbox-item>
              </div>

              <!-- Text filter -->
              <div class="filter-input" *ngIf="isTextFilter(column)">
                <div class="filter-title body-small">Filtrar por texto</div>
                <yalo-input
                  class="filter-input"
                  [placeholder]="'Buscar ' + column.headerName.toLowerCase()"
                  (input)="onTextFilterChange(column, $event)"
                >
                </yalo-input>
              </div>

              <!-- Range filter -->
              <div class="filter-range" *ngIf="isNumberFilter(column)">
                <div class="filter-title body-small">Filtrar por rango</div>
                <div class="range-inputs">
                  <yalo-input
                  class="filter-input"
                    [placeholder]="'Desde'"
                    type="number"
                    (input)="onRangeFilterChange(column, 'from', $event)"
                  >
                  </yalo-input>
                  <yalo-input
                    class="filter-input"
                    [placeholder]="'Hasta'"
                    type="number"
                    (input)="onRangeFilterChange(column, 'to', $event)"
                  >
                  </yalo-input>
                </div>
              </div>

              <!-- select filter -->
              <div class="filter-set" *ngIf="isSetFilter(column)">
                <div class="filter-title body-small">Filtrar por opciones</div>
                <div class="set-options-wrapper">
                  <div class="set-options">
                    <!-- Select All option -->
                    <app-checkbox-item
                    [checked]="AllSelected(column)"
                    (checkedChange)="onSelectAllChange(column, $event)"
                    >
                      <div class="body-small">Seleccionar todo</div>
                    </app-checkbox-item>
                    
                    <!-- Individual options -->
                    <app-checkbox-item
                      *ngFor="let option of column.filterOptions"
                      [checked]="option.selected"
                      (checkedChange)="onSelectFilterChange(column, option)"
                    >
                      <div class="body-small">{{ option.label }}</div>
                    </app-checkbox-item>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <footer>
      <yalo-button type="secondary" (click)="clearFilters()">
        Restablecer
      </yalo-button>
      <yalo-button type="primary" (click)="closeDrawer()">
        Cerrar
      </yalo-button>
    </footer>
  </div>
</app-base-drawer>